import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { ComponentBase } from '../../../../../core/_infrastructure/classes/componentBase';
import { NotificationService } from '../../../../../core/_infrastructure/classes/services/notification.service';
import { AuthService } from '../../../../../core/_infrastructure/classes/services/auth.service';
import { ExceptionManager } from '../../../../../core/_infrastructure/classes/handlers/exceptionManager';
import { FormGroup } from '@angular/forms';
import { DatosCaPeriodoCamViewModel, PeriodoEntidadAuditoraCamViewModel } from '../datosca.types';
import { Tc } from '../../../../../core/_infrastructure/types/common';

@Component({
    selector: 'app-datosca-edit',
    templateUrl: './datosca-edit.component.html',
})
export class DatosCaEditComponent extends ComponentBase implements OnChanges, OnInit {
    @Input() datoscaPeriodo: DatosCaPeriodoCamViewModel;
    @Input() listaEntidadesPeriodo: PeriodoEntidadAuditoraCamViewModel[] = [];
    @Input() formGroup: FormGroup;
    @Input() comunidades: Tc[];
    @Input() usuariosCaAceptacion: Tc[];
    @Input() usuariosCaUnidadInspeccion: Tc[];
    @Input() usuariosCaAforoCorte: Tc[];
    @Input() esPeriodoFinalizado = false;
    @Input() esVigenteConSolicitudes = false;
    @Input() usuariosCaAceptacionRequired = false;
    @Input() usuariosCaUnidadInspeccionRequired = false;
    @Input() usuariosCaAforoCorteRequired = false;
    @Output() deleteEntidadEmitter = new EventEmitter<DatosCaPeriodoCamViewModel>();
    @Output() selectEntidadEmitter = new EventEmitter<number>();

    isCollapsedCabecera = false;
    isCollapsedEntidades = false;
    isCollapsedUsuarioCaDefault = false;

    constructor(
        protected notificationService: NotificationService,
        protected authService: AuthService,
        protected exceptionHandler: ExceptionManager,
    ) {
        super(authService, notificationService, exceptionHandler);
    }

    ngOnInit(): void {
        this.updateForm();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes?.datoscaPeriodo?.currentValue) {
            this.datoscaPeriodo = { ...changes.datoscaPeriodo.currentValue };
            this.updateForm();
        }
    }

    /**
     * This functions sets the values in the datoscaPeriodo (@Input) into the form.
     */
    private updateForm(): void {
        this.formGroup.setValue({
            Id: this.datoscaPeriodo?.Id || 0,
            IdPeriodo: this.datoscaPeriodo?.IdPeriodo || 0,
            IdUsuario: this.datoscaPeriodo?.IdUsuario || 0,
            IdCa: this.datoscaPeriodo?.IdCa || 0,
            NombreUsuario: this.datoscaPeriodo?.NombreUsuario || '',
            ApellidosUsuario: this.datoscaPeriodo?.ApellidosUsuario || '',
            EntidadAuditora: this.datoscaPeriodo?.EntidadAuditora || false,
            ProgramaVerificacion: this.datoscaPeriodo?.ProgramaVerificacion || false,
            IdUsuarioDefaultAceptacion: this.datoscaPeriodo?.IdUsuarioDefaultAceptacion || null,
            IdUsuarioDefaultUnidadInspeccion: this.datoscaPeriodo?.IdUsuarioDefaultUnidadInspeccion || null,
            IdUsuarioDefaultAforoCorte: this.datoscaPeriodo?.IdUsuarioDefaultAforoCorte || null,
        });

        this.listaEntidadesPeriodo = [];
        if (this.datoscaPeriodo != null && this.datoscaPeriodo.Id > 0) {
            this.listaEntidadesPeriodo = this.datoscaPeriodo?.TPeriodoEntidadAuditoraCamCollection;
        }

        this.form = this.formGroup; // componentBase uses this.form
    }

    onSelectEntidad() {
        this.selectEntidadEmitter.emit();
    }

    onDeleteEntidad(item: DatosCaPeriodoCamViewModel) {
        this.deleteEntidadEmitter.emit(item);
    }

    showDeleteButton(item: DatosCaPeriodoCamViewModel): boolean {
        if (this.esPeriodoFinalizado) {
            return false;
        }
        if (this.esVigenteConSolicitudes) {
            return !item.Id;
        }
        return true;
    }

    get title(): string {
        return this.datoscaPeriodo != null && this.datoscaPeriodo.Id > 0 ? 'Editar' : 'Nuevo'; // work mode: edition or creation
    }
}
